import { Grid } from "@mui/material";
import Portada_Home from "./Componentes/Portada_Home";
import Remodelacion_Home from "./Componentes/Remodelacion_Home";
import { Helmet } from "react-helmet";
import Portada_Martha from "./Componentes/Portada_Martha";
import Tecnicas_Martha from "./Componentes/Tecnicas_Martha";
import Proyectos_Martha from "./Componentes/Proyectos_Martha";


const Seccion_Martha = () => {
    return (
        <>
            <Helmet>
                {/* 🔹 Title optimizado (autoridad + marca personal) */}
                <title>Martha Carolina Álvarez | Experta en Mantenimiento Locativo en Cali</title>

                {/* 🔹 Meta descripción (≤155 caracteres) */}
                <meta
                    name="description"
                    content="Martha Carolina Álvarez, especialista en mantenimiento locativo y SST en Cali. Intervenciones técnicas para empresas y copropiedades."
                />

                {/* 🔹 Keywords */}
                <meta
                    name="keywords"
                    content="Martha Carolina Álvarez, mantenimiento locativo Cali, SST Colombia, adecuaciones locativas, infraestructura locativa, Espacio Compacto"
                />

                {/* 🔹 Canonical */}
                <link rel="canonical" href="https://espaciocompacto.com/martha/" />

                {/* 🔹 Open Graph */}
                <meta property="og:title" content="Martha Carolina Álvarez | Espacio Compacto Cali" />
                <meta
                    property="og:description"
                    content="Especialista en mantenimiento locativo y adecuaciones técnicas con enfoque en SST en Cali."
                />
                <meta property="og:url" content="https://espaciocompacto.com/martha/" />
                <meta property="og:type" content="profile" />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Martha Carolina Álvarez | Mantenimiento Locativo Cali" />
                <meta
                    name="twitter:description"
                    content="Experta en adecuaciones locativas y SST en Cali para empresas y copropiedades."
                />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 JSON-LD (Person) */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Person",
                        name: "Martha Carolina Álvarez",
                        jobTitle: "Especialista en Mantenimiento Locativo y SST",
                        worksFor: {
                            "@type": "Organization",
                            name: "Espacio Compacto",
                            url: "https://espaciocompacto.com"
                        },
                        url: "https://espaciocompacto.com/martha/",
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Cali",
                            addressRegion: "Valle del Cauca",
                            addressCountry: "CO"
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
                component="main"
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Portada_Martha/>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Tecnicas_Martha/>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Proyectos_Martha/>
                </Grid>
            </Grid>
        </>
    )
}
export default Seccion_Martha;
